import {useTranslation} from 'next-i18next';
import {ErrorState} from './ErrorState';

interface ErrorInformationI {
  customInformation?: string;
  customDescription?: string;
  onRetry?: () => void;
  compact?: boolean;
}

export const ErrorInformation = ({
  customInformation,
  customDescription,
  onRetry,
  compact,
}: ErrorInformationI) => {
  const {t} = useTranslation();

  return (
    <ErrorState
      title={t(customInformation ?? 'error:default') as string}
      description={t(customDescription ?? 'error:try-again-description') as string}
      onRetry={onRetry}
      retryLabel={t('error:try-again') as string}
      compact={compact}
    />
  );
};
